import React, { useEffect, useState } from "react";
import Breadcrumb from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Tab, Nav } from "react-bootstrap";
import Productlist  from "./Productlist";
import { ProductService } from "../../../services/product-service";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import GroupProducts from "./groupProducts";

export const Content = (props) => {
  const { productID } = useParams();

  const [isVisible, setIsVisible] = useState(false);

  const [productinfo, setProductInfo] = useState({
    name: "",
    description: "",
    weight: "",
    youtube_video: "",
    publisher: "",
    subject: "",
    medium: "",
    type: "",
    grade: "",
    price: "",
    discountPrice: "",
    stock: "",
    low_stock: "",
    product_group_type: "",
    images: "",
    status: "",
    seo_title: "",
    slug: "",
    seo_description: "",
    seo_keyword: "",
    img_alt: "",
    sort_order: "",
  });

  const [groupProductsinfo, setGroupProductsInfo] = useState([]);

  const ProductDetailSearchID = async () => {
    if (productID !== 0) {
    try {
      const result = await ProductService.productDetailsID(productID);

      const info = {};
      const productdata = result;
      info.name = productdata.name;
      info.main_image = productdata.main_image;
      info.description = productdata.description;
      info.weight = productdata.weight;
      info.youtube_video = productdata.youtube_video;
      info.publisher = productdata.publisher.id;
      info.subject = productdata.subject.id;
      info.medium = productdata.medium.id;
      info.type = productdata.type;
      info.grade = productdata.grade;
      info.price = productdata.price;
      info.discountPrice = productdata.discount_price;
      info.stock = productdata.stock;
      info.low_stock = productdata.low_stock
      info.product_group_type = productdata.product_group_type;
      info.images = productdata.images;
      info.category = productdata.level3cat == null ? {} : productdata.level3cat.id;
      info.status = productdata.status;
      info.seo_title = productdata.seo_title;
      info.slug = productdata.slug;
      info.seo_description = productdata.seo_description;
      info.seo_keyword = productdata.seo_keyword;
      info.img_alt = productdata.img_alt;
      info.sort_order = productdata.sort_order;

      setProductInfo(info);
      if(productdata.product_group_type == "group"){
        setGroupProductsInfo(productdata.groupProducts);
        setIsVisible(true);
      }
    } catch (err) {
      //toast
      console.error(err);
    }
  }
  };

  useEffect(() => {
    ProductDetailSearchID(productID);
  }, []);

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Products List Edit</h6>
            </div>
            <div className="ms-panel-body clearfix">
              <Tab.Container defaultActiveKey="tab13">
                <Nav
                  variant="tabs"
                  className="nav nav-tabs d-flex nav-justified mb-4"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="tab13">Products List </Nav.Link>
                  </Nav.Item>
                  {isVisible && <Nav.Item>
                    <Nav.Link eventKey="tab14">Grop Products List</Nav.Link>
                  </Nav.Item>}
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="tab13">
                    <Productlist
                      name={productinfo.name}
                      main_image={productinfo.main_image}
                      description={productinfo.description}
                      weight={productinfo.weight}
                      youtube_video={productinfo.youtube_video}
                      publisher={productinfo.publisher}
                      subject={productinfo.subject}
                      medium={productinfo.medium}
                      type={productinfo.type}
                      grade={productinfo.grade}
                      price={productinfo.price}
                      discountPrice={productinfo.discountPrice}
                      stock={productinfo.stock}
                      low_stock={productinfo.low_stock}
                      product_group_type={productinfo.product_group_type}
                      status={productinfo.status}
                      images={productinfo.images}
                      category={productinfo.category}
                      groupProductsinfo={groupProductsinfo}
                      seo_title={productinfo.seo_title}
                      slug={productinfo.slug}
                      seo_description={productinfo.seo_description}
                      seo_keyword={productinfo.seo_keyword}
                      img_alt={productinfo.img_alt}
                      sort_order={productinfo.sort_order}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="tab14">
                    <GroupProducts groupProductsinfo={groupProductsinfo} stock={productinfo.stock}/>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
